export type Status = 'idle' | 'pending' | 'reloading' | 'success' | 'error';

export interface RequestStatus {
    status: Status;
    loadedTimestamp?: number;
}

interface DataLoadedRequest<T> {
    status: Extract<Status, 'success' | 'reloading'>;
    loadedTimestamp: number;
    data: T;
}

interface DataUnknownRequest<T> {
    status: Exclude<Status, 'success' | 'reloading'>;
    loadedTimestamp?: number;
    data?: T;
}

export type RequestStatusWithDetails<T> = DataLoadedRequest<T> | DataUnknownRequest<T>;

// store this in a const so it keeps the same ref
const emptyReturnObj = { status: 'idle' as const };

export const emptyReturnObject = <T>(): RequestStatusWithDetails<T> => emptyReturnObj;
